// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs__navigation_chain {
    margin: 0 0 10px;
    width: 100%;
}

.breadcrumb__navigation_ol {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 0;
    list-style: none;
    margin: 0;
    padding: 0;
}

.breadcrumb-item {
    align-items: center;
    display: flex;
    font-size: 12px;
    list-style-type: none;
    margin-right: 9px;
}

.breadcrumb-item+.breadcrumb-item::before {
    color: #98948f;
    content: "/";
    padding-right: 9px;
}

.breadcrumb-item a {
    color: #696560;
    text-decoration: none;
}

.breadcrumb-item a:hover {
    color: #171717;
}
.crumb__item_a {
    background-color: transparent;
    color: #696560;
    cursor: pointer;
    font-family: var(--mg-sans);
    font-size: 12px;
    line-height: 1.3;
    transition: color 0.2s ease;
}

.crumb__item_span {
    color: #171717;
    font-family: var(--mg-sans);
    font-size: 12px;
    line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/components/Breadcrumbs/Breadcrumbs.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".breadcrumbs__navigation_chain {\n    margin: 0 0 10px;\n    width: 100%;\n}\n\n.breadcrumb__navigation_ol {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px 0;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.breadcrumb-item {\n    align-items: center;\n    display: flex;\n    font-size: 12px;\n    list-style-type: none;\n    margin-right: 9px;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    color: #98948f;\n    content: \"/\";\n    padding-right: 9px;\n}\n\n.breadcrumb-item a {\n    color: #696560;\n    text-decoration: none;\n}\n\n.breadcrumb-item a:hover {\n    color: #171717;\n}\n.crumb__item_a {\n    background-color: transparent;\n    color: #696560;\n    cursor: pointer;\n    font-family: var(--mg-sans);\n    font-size: 12px;\n    line-height: 1.3;\n    transition: color 0.2s ease;\n}\n\n.crumb__item_span {\n    color: #171717;\n    font-family: var(--mg-sans);\n    font-size: 12px;\n    line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
